import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { formatName } from "../../common/common";
import FormHelperText from '@mui/material/FormHelperText';
import DeleteIcon from '@mui/icons-material/Delete';

export const ReportReviewersComponent = (props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(15);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <React.Fragment>
        {(props.ActionType == 'AddSubProject' ) && 
        <>
        <div className={'section-main'}>
            <div className={'listSubHeader'}>
                <div className={'col-left'}>
                    <Typography component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">
                    </Typography>
                </div>
                <div className={'action'}>
                    <Tooltip title="Add Report Reviewers" aria-label="add">
                        <Fab size="small" color="default" aria-label="add" className={'fab-outline'} onClick={props.OnAddReviewerClick}>
                            <AddIcon />
                        </Fab>
                    </Tooltip>
                </div>
            </div>
                <TableContainer >
                    <Table aria-label="simple table"  >
                        <TableHead>
                            <TableRow>
                                <TableCell> Report Name </TableCell>
                                <TableCell> Reviewer Name </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {props.ReviewerRows !== 'undefined' && props.ReviewerRows.map((row) =>
                        <>
                        <TableRow>
                            <TableCell width="40%">{props.Reports.name}</TableCell> 
                            <TableCell width="50%">
                                <FormControl  variant="standard">
                                <Select
                                    value={row.selectedOption}
                                    onChange={(e) => props.HandleReviewerChange(e, row.id, 'selectedOption')}
                                    inputProps={{
                                        name: 'reviewerName',
                                        id: 'reviewerName',
                                    }}>
                                    <MenuItem value=""><em>-Select-</em></MenuItem>
                                    {typeof props.Users != 'undefined' && props.Users.map((idt, i) =>
                                        <MenuItem value={idt.user_id} key={'idtypes-' + i}>{formatName(idt.first_name, null, idt.last_name)}</MenuItem>
                                    )}
                                </Select>
                                </ FormControl>
                            </TableCell>
                            <TableCell width="10%">
                                <FormControl>
                                    <DeleteIcon fontSize="small" onClick={() => props.DeleteReviewerRow(row.id)} />
                                </FormControl>
                            </TableCell>   
                        </TableRow>
                        </>
                        )}
                        </TableBody>
                    </Table>
            </TableContainer>
        </div>
        </>
        }
        {(props.ActionType == 'Copy') &&
        <>
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Checkbox
                                        onChange={props.HandleCheckboxChange}
                                        inputProps={{
                                        name: "select_all_reviewers",
                                        id: "select_all_reviewers",
                                        }}
                                        checked={props.SelectAllReviewers}
                                        color="primary"
                                    />
                                </TableCell>
                                <TableCell> Report </TableCell>
                                <TableCell> Reviewer </TableCell>
                            </TableRow>
                        </TableHead>
                        {props.ReportReviewers.length === 0 && (
                        <TableBody>
                            <TableRow>
                                <TableCell width="200">No reviewers found</TableCell>
                            </TableRow>
                        </TableBody>
                        )}
                        <TableBody>
                        {Object.keys(props.ReportReviewers)
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                            <>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox
                                        onChange={(e) =>
                                            props.HandleCheckboxChange(
                                            e,
                                            props.ReportReviewers[row].id
                                            )
                                        }
                                        inputProps={{
                                            name: "reviewer_row_select",
                                            id: "reviewer_row_select",
                                        }}
                                        checked={
                                            props.SelectedReviewers.includes(
                                            props.ReportReviewers[row].id
                                            )
                                            ? true
                                            : false
                                        }
                                        color="primary"
                                    />
                                    </TableCell>                      
                                    <TableCell>{props.ReportReviewers[row].report_name}</TableCell>
                                    <TableCell> {props.ReportReviewers[row].user_fullname}</TableCell>
                                </TableRow>
                            </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 30, 50]}
                    component="div"
                    count={props.ReportReviewers.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
        </>
        }
        </React.Fragment>
    );
};
